@use '../../styling/colors.scss' as *;
@use '../../styling/form-controls.scss' as *;

.Radio {
  border: 1px solid $color-grey-disabled;
  appearance: none;
  border-radius: 50%;
  min-width: 16px; // prevent minimize change oval shape
  max-width: 16px; // prevent minimize change oval shape
  width: 16px;
  height: 16px;
  box-sizing: border-box;
  margin-right: 0;
  margin-left: 0;
  margin-top: 0.25px;
  margin-bottom: 0;
  vertical-align: middle;
  cursor: pointer;
  background: white !important;

  &.isChecked {
    border: 1px solid $color-primary-purple;
    background: radial-gradient($color-primary-purple 5px, $color-white 5.5px) !important;
  }

  &:disabled {
    cursor: default;
    background: $color-grey-G !important;
    border: 1px solid $color-secondary-button-border;

    &:checked {
      background: radial-gradient($color-primary-purple-50 5px, $color-white 5.5px) !important;
      border: 1px solid $color-primary-purple-50;
    }
  }

  &:hover:enabled {
    border: 1px solid $color-grey-A;
  }
}
